export enum Unit {
  KM = "km",
  MI = "mi",
}
